import React from 'react'
import { Tooltip } from 'react-tooltip'
import { OrderAppointment } from '../../model'
import { useNavigate } from 'react-router-dom'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

interface AppointmentIndicatorProps {
    appointments: OrderAppointment[] | undefined
    orderId?: number
}

const AppointmentIndicator: React.FunctionComponent<AppointmentIndicatorProps> = (props: AppointmentIndicatorProps) => {
    const { appointments, orderId } = props
    const navigate = useNavigate()

    if (!appointments || appointments.length <= 0) {
        // No appointments available
        return undefined
        // return <div className='text-center text-gray-500 text-xs'>Nog geen afspraken</div>
    }

    const upcomingApp = appointments[0]

    const dateIsUpcoming = (date: string | undefined) => {
        if (!date) {
            return false
        }
        const parsedDate = Date.parse(date)
        const currentDate = Date.parse(new Date().toISOString())
        return parsedDate > currentDate
    }

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault()
        e.stopPropagation()
        if (orderId) {
            navigate(`/dashboard/orders/order/${orderId}/appointments`)
        } else {
            navigate('/dashboard/appointments')
        }
    }

    return (
        <button
            type='button'
            onClick={handleClick}
            className='appearance-none bg-transparent border-none p-0 m-0 cursor-pointer text-inherit'
        >
            <div
                className='flex space-x-1.5 text-[--tb-text] font-semibold items-center justify-center'
                id={`appointmentInfo-${upcomingApp.id}`}
            >
                <DynamicFaIcon iconName='calendar' />
                <span className='underline hover:no-underline'>{appointments.length}</span>
                {dateIsUpcoming(upcomingApp.date) && (
                    <DynamicFaIcon
                        iconName='circle'
                        style={{ fontSize: '0.45rem' }}
                        className='text-[--tb-primary] rounded-full bgPrimaryColor -mt-2 w-[7px] h-[7px]'
                    />
                )}
            </div>
            <Tooltip
                anchorSelect={`#appointmentInfo-${upcomingApp.id}`}
                variant='light'
                className='bg-white bg-opacity-100 p-0 m-0 rounded-lg shadow-lg z-50'
            >
                <div className='flex flex-col items-center gap-y-0.5 py-1 px-1'>
                    <span className='text-xs text-[--tb-textLight]'>
                        {dateIsUpcoming(upcomingApp.date) ? 'eerstvolgende afspraak' : 'meest recente afspraak'}:
                    </span>
                    {upcomingApp.date && (
                        <h4 className='text-[--tb-mainHeading] text-sm font-semibold'>
                            {new Intl.DateTimeFormat('nl-NL', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                            }).format(new Date(upcomingApp.date))}
                        </h4>
                    )}
                    <span className='text-[--tb-linkColor] font-semibold text-xs'>{upcomingApp.concerns}</span>
                </div>
            </Tooltip>
        </button>
    )
}

export default AppointmentIndicator
